// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__2ZU5V","footer":"ModalInfo_footer__mZeKG"};